import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { connect } from 'react-redux';
import { selectImpactedEntities } from '../../modules/changeImpacts.js';

const mapStateToProps = (state, ownProps) => ({
  impactedOwners: selectImpactedEntities(ownProps.id)(
    state
  ).impactsOwners.filter((o) => !o.archived),
});

function TaskOwnerFilter({
  impactedOwners,
  selectedTaskOwnerIds,
  navigateAction,
}) {
  const selectedCount = selectedTaskOwnerIds.length;

  const handleSelect = useCallback(
    (taskOwnerId) =>
      navigateAction({
        taskOwnerIds: taskOwnerId
          ? xor(selectedTaskOwnerIds, [taskOwnerId])
          : [],
      }),
    [selectedTaskOwnerIds]
  );

  const renderMenuItem = useCallback(
    (taskOwner) => (
      <React.Fragment key={taskOwner.id}>
        <MenuItem
          active={selectedTaskOwnerIds.includes(taskOwner.id)}
          eventKey={taskOwner.id}
          onSelect={handleSelect}
        >
          {taskOwner.fullName}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedTaskOwnerIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Task Owner</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="task-status-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>

          <MenuItem divider />
          {impactedOwners.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

TaskOwnerFilter.defaultProps = {
  selectedTaskOwnerIds: [],
};

export default connect(mapStateToProps)(TaskOwnerFilter);
